<template>
  <div class="page_ blue_">
    <div class="content">
      <div class="box_list">
        <div class="list" v-if="claimList.length > 0">
          <div
            class="list_item"
            v-for="(item, index) in claimList"
            :key="item.cliamsId"
          >
            <div class="item_1">
              <div class="flex_">
                <span class="left">{{ $t("claimDetails[0]") || "事后" }}</span>
                <span class="no"
                  >{{ $t("claimDetails[1]") || "报案编号："
                  }}{{ item.claimsId }}</span
                >
              </div>
              <div class="box_">
                <span class="circle_"> </span>
                <span>{{
                  $i18n.locale == "zh-cn"
                    ? item.claimsProgressDesc
                    : "Waiting supplementary materials"
                }}</span>
              </div>
            </div>
            <div class="item_2">
              <span
                >{{ $t("InsuranceInfo[1]") || "保单号" }}：
                {{ item.policyNo }}</span
              >
              <span>{{ $t("claim[6]") || "出险人" }}：{{ item.patient }}</span>
              <span
                >{{ $t("claim[13]") || "就诊日期" }}：{{
                  item.docrcvdt ? item.docrcvdt.substring(0, 10) : ""
                }}</span
              >
              <span
                >{{ $t("claim[11]") || "医疗机构" }}：{{
                  item.providerName
                }}</span
              >
            </div>
            <div class="item_3">
              <span style="color: #999999;">{{
                item.createDate
                  ? item.createDate.substring(0, 10) +
                    " " +
                    item.createDate.substring(11, 19)
                  : ""
              }}</span>
              <div>
                <div style="display:flex;">
                  <!-- <span class="detail" @click="detailClaim(item)">{{$t('claimDetails[7]')||'理赔详情'}}</span> -->
                  <div class="hover_">
                    <img
                      src="../assets/medilinkPC/more.png"
                      alt=""
                      @click="showMore(index, item)"
                    />
                    <div class="cancel" :class="{ flex_: item.popoverVisible }">
                      <span
                        v-if="item.claimsProgressCode === '07'"
                        @click="detail(item)"
                        >{{ $t("preAuth.material") }}</span
                      >
                      <span @click="detailClaim(item)">{{
                        $t("claimDetails[7]") || "理赔详情"
                      }}</span>
                      <!-- <span
                    v-if="item.claimsProgressCode === '07'"
                    @click="changeAccount">{{$t('claimDetails[2]')||'变更账户'}}</span
                  > -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="list list_nodata" v-else>
          <img
            class="nodata_"
            src="../assets/medilinkPC/nodata.jpg"
            alt=""
          />
        </div>
      </div>
      <div class="bottom_">
        <a-button style="color: #fff;" type="primary" @click="addClaimApply"
          >+{{ $t("claimDetails[8]") || "新增理赔申请" }}</a-button
        >
        <div style="display: flex;align-items: center;">
          <span style="margin-right:10px;"
            >{{ $t("claimDetails[21]") || "共" }}{{ pagination.totalPage
            }}{{ $t("claimDetails[22]") || "页" }}</span
          >
          <a-pagination
            show-quick-jumper
            :default-current="1"
            :pageSize="pagination.pageSize"
            :total="pagination.totalNum"
            @change="pageChange"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.page_ {
  position: relative;
  background-color: #fff;
  height: auto;
  overflow: hidden;
  padding: 17px 27px 17px 27px;
  border-radius: 10px;
  color: #394155;
  .content {
    position: relative;
    .status {
      margin-left: 46px;
      &:first-child {
        margin-left: 10px;
      }
    }
    .blue {
      color: #2c5acc;
    }
    .box_list {
      min-height: 60vh;
    }
    .list {
      display: flex;
      flex-wrap: wrap;
      // min-height:60vh;
      .list_item {
        width: 32%;
        // height: 230px;
        border-radius: 5px;
        margin-top: 30px;
        margin-right: 2%;
        box-shadow: 0px 2px 20px 0px rgba(0, 0, 0, 0.05);
        border-radius: 6px;
        padding: 25px 30px;
        border: 1px solid transparent;
        &:nth-child(3n + 3) {
          margin-right: 0;
        }
        .item_1 {
          display: flex;
          justify-content: space-between;
          font-size: 14px;
          .flex_ {
            display: flex;
            align-items: center;
          }
          .left {
            display: inline-block;
            // width: 43px;
            font-size: 10px;
            // height: 21px;
            // line-height:21px;
            padding: 1px 5px;
            border: 1px #2c5acc solid;
            margin-right: 10px;
            text-align: center;
            color: #2c5acc;
            border-radius: 3px;
          }
          .no {
            font-size: 16px;
            font-weight: bold;
          }
        }
        .item_2 {
          display: flex;
          flex-direction: column;
          margin-top: 10px;
          line-height: 24px;
        }
        .item_3 {
          position: relative;
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-top: 23px;
          color: #2c5acc;
          img {
            margin-left: 5px;
            width: 20px;
            height: 20px;
          }

          .cancel {
            position: absolute;
            bottom: 30px;
            right: 0;
            // width: 82px;
            padding: 4px 15px;
            text-align: center;
            box-shadow: 0px -4px 10px 0px rgba(0, 0, 0, 0.05);
            border-radius: 3px;
            background-color: #fff;
            z-index: 2;
            display: none;
            flex-direction: column;
            &.flex_ {
              display: flex;
            }
            span {
              height: 30px;
              line-height: 30px;
              cursor: pointer;
              text-align: center;
            }
          }
        }
        &:hover {
          border: 1px solid #2c5acc;
          // .cancel{
          //   display:flex;
          // }
        }
      }
      .nodata_ {
        width: 81px;
        margin-top: 150px;
        height: 91px;
      }
    }
    .list_nodata {
      justify-content: center;
    }
    .bottom_ {
      // position: absolute;
      bottom: 20px;
      display: flex;
      justify-content: space-between;
      // margin-right: 50px;
      margin-top: 20px;
      width: 100%;
    }
  }
}
.box_ {
  display: flex;
  align-items: center;
}
.circle_ {
  display: inline-block;
  width: 4px;
  height: 4px;
  border-radius: 4px;
  background-color: #2c5acc;
  margin-right: 3px;
}
</style>

<script>
import api from "@/utils/api";
export default {
  data() {
    return {
      addVisible: false,
      pagination: {
        pageNum: 1,
        pageSize: 9,
        totalNum: 0,
        totalPage: 0
      },
      claimList: [],
      oriClaimList: [],
      query: {
        status: "07", // 固定传07
        fromRowNum: 1,
        toRowNum: 100
      }
    };
  },
  mounted() {
    this.getCalimsAppPatchFileList();
  },
  methods: {
    showMore(index, item) {
      // item.popoverVisible = !item.popoverVisible
      this.claimList[index].popoverVisible = !this.claimList[index]
        .popoverVisible;
      console.log(this.claimList);
    },
    cancel(item) {
      let this_ = this;
      this.$confirm({
        title: this.$t("alertPrompt[0]"),
        content: this.$t("alertPrompt[1]"),
        okText: this.$t("alertPrompt[2]"),
        okType: "danger",
        cancelText: this.$t("alertPrompt[3]"),
        onOk() {
          this_.claimCancel(item);
        },
        onCancel() {
          console.log("Cancel");
        }
      });
    },
    claimCancel() {
      let param = {
        claims_id: item.iclaimsId,
        Update_by: item.policyNo,
        flag: "0",
        remark: ""
      };
      api
        .claimCancel(param)
        .then(res => res.data)
        .then(data => {
          this.$message.success(data.msg);
          this.$router.push({ name: "ClaimQuery" });
        });
    },
    detail(item) {
      let storageItem = {
        cliamsId: item.claimsId,
        claimsStatus: item.claimsProgressCode,
        claimsDesc: item.claimsProgressDesc,
        iclaimsId: item.claims_id,
        claimsType: item.claimsType
      };
      localStorage.setItem("supplementDetail", JSON.stringify(storageItem));
      this.$router.push({
        name: "ClaimSupplementDetail"
      });
    },
    addClaimApply() {
      this.$router.push({ name: "ClaimApply" });
    },
    changeAccount() {
      this.$router.push({ name: "Info" });
    },
    detailClaim(item) {
      if (item.claimsType === "0") {
        this.$router.push({
          name: "AppClaimDetail",
          query: { cliamsId: item.claimsId }
        });
      } else {
        this.$router.push({
          name: "ClaimDetail",
          query: { cliamsId: item.claimsId, claimsType: item.claimsType }
        });
      }
    },
    getCalimsAppPatchFileList() {
      api
        .getCalimsAppPatchFileList(this.query)
        .then(res => res.data)
        .then(data => {
          console.log(data);
          // data.data = [
          //   {
          //     "approvalCode": "917015",
          //     "docrcvdt": "2019/08/16 00:00:00",
          //     "claimsId": "30739926",
          //     "insured": "杨迪",
          //     "diagnosis": "阿米巴性肠炎",
          //     "remarkCatgDesc": "病历",
          //     "claimsProgressCode": "07",
          //     "claimsProgressDesc":"待补充理赔材料",
          //     "policyNo": "890000023963",
          //     "remarkCatg": "LV",
          //     "providerName": "北京协和医院国际医疗部 ",
          //     "createDate": "2019-08-16T09:52:48.000+0000",
          //     "claimsType":"1"
          //   },
          //   {
          //     "approvalCode": "917015",
          //     "docrcvdt": "2019/08/16 00:00:00",
          //     "claimsId": "3073992623",
          //     "insured": "杨迪",
          //     "diagnosis": "阿米巴性肠炎",
          //     "remarkCatgDesc": "病历",
          //     "claimsProgressCode": "07",
          //     "claimsProgressDesc":"待补充理赔材料",
          //     "policyNo": "890000023963",
          //     "remarkCatg": "LV",
          //     "providerName": "北京协和医院国际医疗部 ",
          //     "createDate": "2019-08-16T09:52:48.000+0000",
          //     "claimsType":"1"
          //   },
          //   {
          //     "approvalCode": "917015",
          //     "docrcvdt": "2019/08/16 00:00:00",
          //     "claimsId": "3073439926",
          //     "insured": "杨迪",
          //     "diagnosis": "阿米巴性肠炎",
          //     "remarkCatgDesc": "病历",
          //     "claimsProgressCode": "07",
          //     "claimsProgressDesc":"待补充理赔材料",
          //     "policyNo": "890000023963",
          //     "remarkCatg": "LV",
          //     "providerName": "北京协和医院国际医疗部 ",
          //     "createDate": "2019-08-16T09:52:48.000+0000",
          //     "claimsType":"1"
          //   },
          //   {
          //     "approvalCode": "917015",
          //     "docrcvdt": "2019/08/16 00:00:00",
          //     "claimsId": "3073439926",
          //     "insured": "杨迪",
          //     "diagnosis": "阿米巴性肠炎",
          //     "remarkCatgDesc": "病历",
          //     "claimsProgressCode": "07",
          //     "claimsProgressDesc":"待补充理赔材料",
          //     "policyNo": "890000023963",
          //     "remarkCatg": "LV",
          //     "providerName": "北京协和医院国际医疗部 ",
          //     "createDate": "2019-08-16T09:52:48.000+0000",
          //     "claimsType":"1"
          //   },
          //   {
          //     "approvalCode": "917015",
          //     "docrcvdt": "2019/08/16 00:00:00",
          //     "claimsId": "3073439926",
          //     "insured": "杨迪",
          //     "diagnosis": "阿米巴性肠炎",
          //     "remarkCatgDesc": "病历",
          //     "claimsProgressCode": "07",
          //     "claimsProgressDesc":"待补充理赔材料",
          //     "policyNo": "890000023963",
          //     "remarkCatg": "LV",
          //     "providerName": "北京协和医院国际医疗部 ",
          //     "createDate": "2019-08-16T09:52:48.000+0000",
          //     "claimsType":"1"
          //   },
          //   {
          //     "approvalCode": "917015",
          //     "docrcvdt": "2019/08/16 00:00:00",
          //     "claimsId": "3073439926",
          //     "insured": "杨迪",
          //     "diagnosis": "阿米巴性肠炎",
          //     "remarkCatgDesc": "病历",
          //     "claimsProgressCode": "07",
          //     "claimsProgressDesc":"待补充理赔材料",
          //     "policyNo": "890000023963",
          //     "remarkCatg": "LV",
          //     "providerName": "北京协和医院国际医疗部 ",
          //     "createDate": "2019-08-16T09:52:48.000+0000",
          //     "claimsType":"1"
          //   },
          //   {
          //     "approvalCode": "917015",
          //     "docrcvdt": "2019/08/16 00:00:00",
          //     "claimsId": "30739926",
          //     "insured": "杨迪",
          //     "diagnosis": "阿米巴性肠炎",
          //     "remarkCatgDesc": "病历",
          //     "claimsProgressCode": "07",
          //     "claimsProgressDesc":"待补充理赔材料",
          //     "policyNo": "890000023963",
          //     "remarkCatg": "LV",
          //     "providerName": "北京协和医院国际医疗部 ",
          //     "createDate": "2019-08-16T09:52:48.000+0000",
          //     "claimsType":"1"
          //   },
          //   {
          //     "approvalCode": "917015",
          //     "docrcvdt": "2019/08/16 00:00:00",
          //     "claimsId": "3073992623",
          //     "insured": "杨迪",
          //     "diagnosis": "阿米巴性肠炎",
          //     "remarkCatgDesc": "病历",
          //     "claimsProgressCode": "07",
          //     "claimsProgressDesc":"待补充理赔材料",
          //     "policyNo": "890000023963",
          //     "remarkCatg": "LV",
          //     "providerName": "北京协和医院国际医疗部 ",
          //     "createDate": "2019-08-16T09:52:48.000+0000",
          //     "claimsType":"1"
          //   },
          //   {
          //     "approvalCode": "917015",
          //     "docrcvdt": "2019/08/16 00:00:00",
          //     "claimsId": "3073439926",
          //     "insured": "杨迪",
          //     "diagnosis": "阿米巴性肠炎",
          //     "remarkCatgDesc": "病历",
          //     "claimsProgressCode": "07",
          //     "claimsProgressDesc":"待补充理赔材料",
          //     "policyNo": "890000023963",
          //     "remarkCatg": "LV",
          //     "providerName": "北京协和医院国际医疗部 ",
          //     "createDate": "2019-08-16T09:52:48.000+0000",
          //     "claimsType":"1"
          //   },
          //   {
          //     "approvalCode": "917015",
          //     "docrcvdt": "2019/08/16 00:00:00",
          //     "claimsId": "3073439926",
          //     "insured": "杨迪",
          //     "diagnosis": "阿米巴性肠炎",
          //     "remarkCatgDesc": "病历",
          //     "claimsProgressCode": "07",
          //     "claimsProgressDesc":"待补充理赔材料",
          //     "policyNo": "890000023963",
          //     "remarkCatg": "LV",
          //     "providerName": "北京协和医院国际医疗部 ",
          //     "createDate": "2019-08-16T09:52:48.000+0000",
          //     "claimsType":"1"
          //   },
          //   {
          //     "approvalCode": "917015",
          //     "docrcvdt": "2019/08/16 00:00:00",
          //     "claimsId": "3073439926",
          //     "insured": "杨迪",
          //     "diagnosis": "阿米巴性肠炎",
          //     "remarkCatgDesc": "病历",
          //     "claimsProgressCode": "07",
          //     "claimsProgressDesc":"待补充理赔材料",
          //     "policyNo": "890000023963",
          //     "remarkCatg": "LV",
          //     "providerName": "北京协和医院国际医疗部 ",
          //     "createDate": "2019-08-16T09:52:48.000+0000",
          //     "claimsType":"1"
          //   },
          //   {
          //     "approvalCode": "917015",
          //     "docrcvdt": "2019/08/16 00:00:00",
          //     "claimsId": "3073439926",
          //     "insured": "杨迪",
          //     "diagnosis": "阿米巴性肠炎",
          //     "remarkCatgDesc": "病历",
          //     "claimsProgressCode": "07",
          //     "claimsProgressDesc":"待补充理赔材料",
          //     "policyNo": "890000023963",
          //     "remarkCatg": "LV",
          //     "providerName": "北京协和医院国际医疗部 ",
          //     "createDate": "2019-08-16T09:52:48.000+0000",
          //     "claimsType":"1"
          //   }
          // ]
          this.pagination.totalNum = data.data.length;
          // 总页数=(总页数+页大小-1)/页大小
          this.pagination.totalPage = parseInt(
            (this.pagination.totalNum + this.pagination.pageSize - 1) /
              this.pagination.pageSize
          );
          console.log(this.pagination);
          this.oriClaimList = data.data;
          let list = JSON.parse(JSON.stringify(this.oriClaimList));
          list.forEach(item => {
            item.popoverVisible = false;
          });
          this.claimList = list.splice(0, 9);
        });
    },
    pageChange(pageNum, pageSize) {
      this.pagination.pageNum = pageNum;
      this.toPage();
    },
    toPage() {
      this.claimList = JSON.parse(JSON.stringify(this.oriClaimList));
      let page = (this.pagination.pageNum - 1) * 9;
      this.claimList = this.claimList.splice(page, this.pagination.pageSize);
    },
    pointStatusChange(value) {
      this.query.timeFlag = value;
      this.getCalimsAppPatchFileList();
      console.log(value);
    },
    statusChage(index, value) {
      this.statusIndex = index;
      this.query.type = value;
      console.log(this.query);
      this.getCalimsAppPatchFileList();
    },
    callback(key) {
      console.log(key);
    },
    addCard() {
      this.addVisible = true;
    }
  }
};
</script>
